import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/lib/query/query-keys';
import { apiFetch } from '@/lib/api/client';

async function cancelTrip(tripId: string): Promise<void> {
  const response = await apiFetch(`/api/v1/business-trip-requests/${tripId}/cancel`, {
    method: 'POST',
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    const message =
      payload && typeof payload === 'object' && 'error' in (payload as Record<string, unknown>)
        ? String(
            (payload as Record<string, { message?: string }>).error?.message ??
              'Failed to cancel trip'
          )
        : 'Failed to cancel trip';

    throw new Error(message);
  }
}

export function useCancelTrip() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelTrip,
    onSuccess: (_result, tripId) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.trips });
      queryClient.invalidateQueries({ queryKey: queryKeys.tripApprovals });
      if (tripId) {
        queryClient.invalidateQueries({ queryKey: queryKeys.trip(tripId) });
      }
    },
    onError: (error) => {
      console.error('Error canceling trip:', error);
    },
  });
}
